// src/constants/timeFrames.js

/**
 * Time frames that look forward only — used to determine whether
 * expired sales should be filtered out of the results.
 */
export const FUTURE_TIME_FRAMES = [
  "All Future Sale Dates",
  "Next 30 Days",
  "Next 60 Days",
  "Next 90 Days",
  "Next 6 Months",
  "Next 1 Year",
];

/**
 * Full list of time frame options shown in the filter dropdown.
 */
export const TIME_FRAMES = [
  "All Future Sale Dates",
  "Past 4 Weeks",
  "Next 30 Days",
  "Next 60 Days",
  "Next 90 Days",
  "Next 6 Months",
  "Next 1 Year",
];

export const isPastTimeFrame = (timeFrame) => !!timeFrame && !FUTURE_TIME_FRAMES.includes(timeFrame);